import { Rda } from "./rda.model";
import { Moment } from "moment";

export class EnvioRda{

  id: number;
  rda: Rda;
  nrProcessoSei: string;
  dataEnvio: Moment;
  dataAlteracao: Moment;
  alteracao: boolean;
  numeroRecibo: string;
  idArquivoRdaEnviado: string;
  idArquivoRecibo: string;

  constructor(init?: Partial<EnvioRda>){
    Object.assign(this, init);
  }
}
